import useAuthorization from "#/hooks/useAuthorization";

export default function CurrentAuthorization() {
  const { remove, label } = useAuthorization({ load: false });

  return (
    <div className="is-clickable">
      <span
        className="button authorization-button has-text-weight-normal is-small is-primary"
        onClick={remove}>
        {label}
        <span className="icon icon-chevron-down ml-1" />
      </span>
    </div>
  );
}
